import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Result, Spin } from "antd";
import { postApi } from "@utils";

export const StripeReturn = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    handleReturn();
  }, []);

  const handleReturn = async () => {
    try {
      const response = await postApi("postStripeConnectReturn", {});
      if (response?.data?.fully_onboarded) {
        setSuccess(true);
        setTimeout(() => {
          navigate("/stripe-settings");
        }, 3000);
      } else {
        navigate("/stripe-settings");
      }
    } catch (error) {
      navigate("/stripe-settings");
    }
    setLoading(false);
  };

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "100px" }}>
        <Spin size="large" />
        <p>Verifying your Stripe account...</p>
      </div>
    );
  }

  if (success) {
    return (
      <Result
        status="success"
        title="Stripe Account Connected Successfully!"
        subTitle="You can now receive payouts. Redirecting to settings..."
      />
    );
  }

  return null;
};
